var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service__item",on:{"click":function($event){
var ref;
return (ref = _vm.service.onclick).function.apply(ref, _vm.service.onclick.paramsArr)}}},[_c('div',{staticClass:"service__icon"},[_c('a-icon',{attrs:{"type":_vm.service.icon}})],1),_c('div',{staticClass:"service__title"},[_vm._v(" "+_vm._s(_vm.translatedName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }